import { HttpError } from "@/src/common/services/api-error";
import { handleSessionExpired, tryRefreshSession } from "@/src/common/services/http.service";
import { getAccessToken } from "@/src/common/services/token-store.service";

const attempt = async (url: string, method: string, body: unknown): Promise<Response> => {
	const accessToken = await getAccessToken();
	const headers: Record<string, string> = { "content-type": "application/json" };
	if (accessToken) {
		headers.authorization = `Bearer ${accessToken}`;
	}
	return fetch(url, { method, headers, body: body === undefined ? undefined : JSON.stringify(body) });
};

export const requestJson = async (url: string, method: string, body?: unknown): Promise<unknown> => {
	let response = await attempt(url, method, body);
	if (response.status === 401 && (await tryRefreshSession())) {
		response = await attempt(url, method, body);
	}
	if (!response.ok) {
		if (response.status === 401) {
			await handleSessionExpired();
		}
		const value: unknown = await response.json().catch(() => null);
		throw new HttpError(response.status, value);
	}
	return response.json();
};
